import { SettingsSubSection } from './settings-sub-section.model';

export class SettingsSection {
  constructor(
    public key: string,
    public label: string,
    public description: string,
    public subsections: Array<SettingsSubSection>
  ) {}
}
